import { UserNotificationCategory } from './user-notification-category';

export class UserNotificationCategoryCampaign {
	public id: number;
	public name: string;
	public description: string;
	public leadTypeId: number;
	public userNotificationCategoryCampaignTypeId: number;

	public userNotificationCategories: UserNotificationCategory[];

	constructor(userNotificationCategoryCampaign?: UserNotificationCategoryCampaign) {
		Object.assign(this, userNotificationCategoryCampaign);
	}
}
